export default __webpack_public_path__ + "static/media/arrow.fa7184ac.svg";